import { render, staticRenderFns } from "./DramaEpisodeUnlockManagement.vue?vue&type=template&id=1e83a4c4&scoped=true"
import script from "./DramaEpisodeUnlockManagement.vue?vue&type=script&lang=js"
export * from "./DramaEpisodeUnlockManagement.vue?vue&type=script&lang=js"
import style0 from "./DramaEpisodeUnlockManagement.vue?vue&type=style&index=0&id=1e83a4c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e83a4c4",
  null
  
)

export default component.exports